/* Giftera – panoul „Designul tău pentru card”: poză + text → previzualizare pe canvas → proprietăți pe linia din coș.
   Portat din tema live. Numele, valorile și ordinea proprietăților sunt contract cu aplicația de depozit.
   Previzualizarea e un buton: o atingere o deschide mărită într-un <dialog> (X, Esc, atingere pe fundal).

   Fluxul de trimitere (docs/SPEC-PDP.md §1):
   1. `submit` pe formular, în faza de CAPTURĂ. La „Mesajul nostru” doar dezactivează proprietățile și iese.
   2. La „Designul tău”: validează, urcă poza + previzualizarea în Cloudinary, completează inputurile,
      apoi apelează form.requestSubmit(buton) cu un flag intern; a doua trecere ajunge la handlerul din
      faza bubble (assets/giftera-product.js), care adaugă setul.
   3. Add-on-ul `card-personalizat` se adaugă DUPĂ set, din window.Giftera.afterSetAdded, cu aceeași
      cantitate și `Pentru` = titlul produsului. Dacă setul eșuează (`gf:set-add-failed`), nu se adaugă.
   4. Dacă formularul nu are atributul `data-gf-ajax` (giftera-product.js nu a pornit), a doua trecere e un
      POST nativ: add-on-ul se adaugă atunci înaintea setului, ca în live. */
(function () {
  if (customElements.get('gf-card-designer')) return;

  var SIZE = 1200;
  // Fontul de tipar e fix (decizia 11) – același ca în tema live (Instrument Serif pentru text,
  // Instrument Sans doar pentru textul-ghid al previzualizării goale), indiferent de fonturile temei.
  var FONT_TEXT = '"Instrument Serif", Georgia, serif';
  var FONT_HINT = '"Instrument Sans", Arial, sans-serif';
  var DEFAULTS = {
    error_empty: 'Scrie un mesaj sau încarcă o poză pentru cardul tău.',
    error_addon: 'Nu am putut adăuga cardul personalizat. Încearcă din nou sau scrie-ne.',
    warn_format: 'Formatul nu e suportat. Salvează poza ca JPG sau PNG și încearcă din nou.',
    warn_small: 'Poza are doar %px% px — la tipar va ieși neclară. Încarcă originalul, de minimum 1500 px.',
    warn_medium: 'Poza are %px% px. Merge, dar recomandăm minim 1500 px pentru un tipar clar.',
    warn_unreadable: 'Nu am putut citi poza. Dacă e în format HEIC, salveaz-o ca JPG sau PNG și încearcă din nou.',
    canvas_empty_1: 'Încarcă o poză și scrie mesajul —',
    canvas_empty_2: 'previzualizarea apare aici'
  };

  class GfCardDesigner extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.canvas = this.querySelector('canvas[data-gf="canvas"]') || this.querySelector('canvas');
      if (!this.canvas) return;
      this._ready = true;

      this.formId = this.dataset.formId;
      this.form = document.getElementById(this.formId);
      this.shape = this.dataset.shape || 'patrat';
      this.cloud = (this.dataset.cloud || '').trim();
      this.preset = (this.dataset.preset || '').trim();
      // produsul ascuns „Card personalizat” (gratuit) — linie separată în coș,
      // ca setul să rămână un singur produs cu o singură ofertă în feed
      this.addonVariant = (this.dataset.addonVariant || '').trim();
      this.addonAvailable = this.dataset.addonAvailable !== 'false';
      this.productTitle = this.dataset.productTitle || '';
      this.ctx = this.canvas.getContext('2d');
      this.q = (k) => this.querySelector('[data-gf="' + k + '"]');
      this.props = {};
      this.querySelectorAll('[data-gf-prop]').forEach((el) => (this.props[el.dataset.gfProp] = el));
      this.strings = Object.assign({}, DEFAULTS);
      try { Object.assign(this.strings, JSON.parse(this.q('strings').textContent)); } catch (err) { /* textele implicite */ }
      this.image = null;
      this.file = null;
      this.busy = false;       // urcare în curs
      this.passThrough = false; // a doua trecere a evenimentului submit
      this.pendingAddon = false; // setul trimis acum e „Designul tău” → după el vine add-on-ul

      ['title', 'message', 'sign'].forEach((k) => {
        const el = this.q(k);
        if (el) el.addEventListener('input', () => { this.count(); this.render(); });
      });
      this.querySelectorAll('[data-gf="style"]').forEach((r) => r.addEventListener('change', () => this.render()));
      const photo = this.q('photo');
      if (photo) photo.addEventListener('change', (e) => this.setFile(e.target.files && e.target.files[0]));
      const drop = this.q('drop');
      if (drop) {
        ['dragenter', 'dragover'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.add('is-over'); }));
        ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.remove('is-over'); }));
        drop.addEventListener('drop', (e) => { const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (f) this.setFile(f); });
      }
      const remove = this.q('remove-photo');
      if (remove) remove.addEventListener('click', () => this.setFile(null));
      const guide = this.q('guide');
      const openGuide = this.q('open-guide');
      if (guide && openGuide) {
        openGuide.addEventListener('click', () => this.openGuide());
        this.querySelectorAll('[data-gf="close-guide"]').forEach((b) => b.addEventListener('click', () => guide.close()));
        guide.addEventListener('click', (e) => { if (e.target === guide) guide.close(); });
        guide.addEventListener('close', () => openGuide.focus({ preventScroll: true }));
      }

      // previzualizarea mărită
      const zoom = this.q('zoom');
      const openZoom = this.q('open-zoom');
      if (zoom && openZoom) {
        openZoom.addEventListener('click', () => this.openZoom());
        // dialogul acoperă tot ecranul: orice atingere în afara cardului (fundalul) îl închide
        zoom.addEventListener('click', (e) => { if (e.target !== this.q('zoom-canvas')) zoom.close(); });
        zoom.addEventListener('close', () => openZoom.focus({ preventScroll: true }));
      }

      // apare / dispare odată cu alegerea din blocul „Cardul: mesajul nostru sau al tău”
      this.onChoice = (e) => {
        const t = e.target;
        if (t && t.matches && t.matches('input[data-gf-custom]') && t.checked) this.toggle(t.dataset.gfCustom === 'true');
      };
      document.addEventListener('change', this.onChoice, true);

      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e), true);

      // add-on-ul intră în coș după set (SPEC-PDP §1, pasul 5)
      const G = (window.Giftera = window.Giftera || {});
      if (!Array.isArray(G.afterSetAdded)) G.afterSetAdded = [];
      this.afterSetAdded = (detail) => this.onSetAdded(detail || {});
      G.afterSetAdded.push(this.afterSetAdded);
      this.onSetFailed = () => { this.pendingAddon = false; };
      document.addEventListener('gf:set-add-failed', this.onSetFailed);

      // starea radio-urilor poate fi restaurată de browser (reîncărcare, înapoi)
      const checked = document.querySelector('input[data-gf-custom]:checked');
      this.toggle(!!checked && checked.dataset.gfCustom === 'true');
      this.count();
      this.render();
    }

    disconnectedCallback() {
      if (!this._ready) return;
      document.removeEventListener('change', this.onChoice, true);
      document.removeEventListener('gf:set-add-failed', this.onSetFailed);
      const list = window.Giftera && window.Giftera.afterSetAdded;
      if (Array.isArray(list)) {
        const i = list.indexOf(this.afterSetAdded);
        if (i > -1) list.splice(i, 1);
      }
      this._ready = false;
    }

    t(key, vars) {
      let s = this.strings[key] || '';
      Object.keys(vars || {}).forEach((k) => { s = s.split('%' + k + '%').join(vars[k]); });
      return s;
    }

    toggle(custom) {
      this.hidden = !custom;
      document.querySelectorAll('[data-gf-total]').forEach((el) => (el.hidden = !custom));
      Object.values(this.props).forEach((el) => (el.disabled = !custom));
      if (custom) { this.syncProps(); requestAnimationFrame(() => this.render()); }
      else this.showError('', true);
    }

    openGuide() {
      const d = this.q('guide');
      if (!d || d.open) return;
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    }

    /* Copia mărită a previzualizării: același canvas, redesenat la aceeași rezoluție și scalat din CSS. */
    paintZoom() {
      const d = this.q('zoom');
      const copy = this.q('zoom-canvas');
      if (!d || !d.open || !copy) return;
      const c = copy.getContext('2d');
      c.clearRect(0, 0, copy.width, copy.height);
      c.drawImage(this.canvas, 0, 0, copy.width, copy.height);
    }

    openZoom() {
      const d = this.q('zoom');
      if (!d || d.open) return;
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      this.paintZoom();
    }

    /* Contorul mesajului: „x / 320”. */
    count() {
      const out = this.q('count');
      const field = this.q('message');
      if (out && field) out.textContent = String(field.value.length);
    }

    /* Fonturile canvasului: se cer explicit, cu textul curent (subsetul latin-ext pentru ș/ț vine doar
       dacă e nevoie de el). Promisiunea nu respinge niciodată: fără rețea se desenează cu Georgia/Arial. */
    loadFonts() {
      if (!document.fonts || typeof document.fonts.load !== 'function') return Promise.resolve();
      const text = [this.val('title'), this.val('message'), this.val('sign'), this.strings.canvas_empty_1, this.strings.canvas_empty_2, 'ăâîșț'].join(' ');
      return Promise.all([
        document.fonts.load('400 46px "Instrument Serif"', text),
        document.fonts.load('italic 400 38px "Instrument Serif"', text),
        document.fonts.load('400 34px "Instrument Sans"', text)
      ]).catch(() => {});
    }

    val(k) {
      const el = this.q(k);
      return el ? el.value.trim() : '';
    }

    setFile(file) {
      const warn = this.q('photo-warn');
      const name = this.q('filename');
      const remove = this.q('remove-photo');
      const showWarn = (msg) => { if (warn) { warn.textContent = msg; warn.hidden = !msg; } };
      showWarn('');
      if (!file) {
        this.file = null; this.image = null;
        if (name) name.textContent = name.dataset.empty || '';
        if (remove) remove.hidden = true;
        const input = this.q('photo');
        if (input) input.value = '';
        this.render();
        return;
      }
      if (!/^image\//.test(file.type)) {
        showWarn(this.t('warn_format'));
        return;
      }
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(url);
        this.file = file; this.image = img;
        if (name) name.textContent = file.name + ' · ' + img.naturalWidth + '×' + img.naturalHeight + ' px';
        if (remove) remove.hidden = false;
        const m = Math.min(img.naturalWidth, img.naturalHeight);
        if (m < 800) showWarn(this.t('warn_small', { px: m }));
        else if (m < 1500) showWarn(this.t('warn_medium', { px: m }));
        this.showError('', true);
        this.render();
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        showWarn(this.t('warn_unreadable'));
      };
      img.src = url;
    }

    styleMode() {
      const r = this.querySelector('[data-gf="style"]:checked');
      const v = r ? r.value : 'auto';
      if (v !== 'auto') return v;
      return this.image ? 'light' : 'dark';
    }

    wrap(ctx, text, maxWidth) {
      const lines = [];
      String(text || '').split(/\r?\n/).forEach((para) => {
        let line = '';
        para.split(/\s+/).forEach((word) => {
          if (!word) return;
          const test = line ? line + ' ' + word : word;
          if (ctx.measureText(test).width > maxWidth && line) { lines.push(line); line = word; } else line = test;
        });
        lines.push(line);
      });
      return lines;
    }

    /* Cardul are conținut dacă e scris ceva în Titlu, Mesaj sau Semnătură ori e încărcată o poză
       (aceeași condiție după care draw() scrie textul-ghid pe cardul gol). Doar citire. */
    get hasContent() {
      return !!(this.val('title') || this.val('message') || this.val('sign') || this.image);
    }

    /* Anunță fiecare redesenare: cine vrea aceeași previzualizare (pasul 3 din „Ce găsește…”,
       assets/giftera-unboxing.js) copiază canvasul din detail, fără să deseneze el ceva. */
    announce() {
      this.dispatchEvent(new CustomEvent('gf:card-preview', {
        bubbles: true,
        detail: { canvas: this.canvas, hasContent: this.hasContent }
      }));
    }

    /* Desenează acum și încă o dată după ce fonturile pentru textul curent sunt gata. */
    render() {
      this.draw();
      this.syncProps();
      const turn = (this.renderTurn = (this.renderTurn || 0) + 1);
      this.paintZoom();
      this.announce();
      this.loadFonts().then(() => { if (turn === this.renderTurn) { this.draw(); this.paintZoom(); this.announce(); } });
    }

    draw() {
      const ctx = this.ctx, S = SIZE, round = this.shape === 'rotund';
      const heading = FONT_TEXT, body = FONT_HINT;
      const mode = this.styleMode();
      const light = mode === 'light';
      ctx.save();
      ctx.clearRect(0, 0, S, S);
      if (round) { ctx.beginPath(); ctx.arc(S / 2, S / 2, S / 2 - 2, 0, Math.PI * 2); ctx.closePath(); ctx.clip(); }
      // fundal
      if (this.image) {
        const img = this.image, r = Math.max(S / img.naturalWidth, S / img.naturalHeight);
        const w = img.naturalWidth * r, h = img.naturalHeight * r;
        ctx.drawImage(img, (S - w) / 2, (S - h) / 2, w, h);
        const g = ctx.createLinearGradient(0, S * 0.35, 0, S);
        if (light) { g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,0.72)'); }
        else { g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(255,255,255,0.88)'); }
        ctx.fillStyle = g; ctx.fillRect(0, 0, S, S);
      } else {
        ctx.fillStyle = light ? '#1C1A17' : '#FBF9F6';
        ctx.fillRect(0, 0, S, S);
        // chenar interior discret
        ctx.strokeStyle = light ? 'rgba(255,255,255,0.25)' : 'rgba(28,26,23,0.18)';
        ctx.lineWidth = 3;
        if (round) { ctx.beginPath(); ctx.arc(S / 2, S / 2, S / 2 - 56, 0, Math.PI * 2); ctx.stroke(); }
        else ctx.strokeRect(56, 56, S - 112, S - 112);
      }
      // text
      const title = this.val('title');
      const message = this.val('message');
      const sign = this.val('sign');
      const color = light ? '#FFFFFF' : '#1C1A17';
      const sub = light ? 'rgba(255,255,255,0.86)' : 'rgba(28,26,23,0.8)';
      const maxW = round ? S * 0.6 : S * 0.8;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'alphabetic';
      const msgSize = 46, signSize = 38, lh = 1.32;
      // titlul stă pe un rând; unul lung se micșorează cât să încapă între margini, nu trece peste ele
      let titleSize = 86;
      if (title) {
        ctx.font = '400 ' + titleSize + 'px ' + heading;
        const titleW = ctx.measureText(title).width;
        if (titleW > maxW) titleSize = Math.max(48, Math.floor(titleSize * maxW / titleW));
      }
      ctx.font = '400 ' + msgSize + 'px ' + heading;
      const msgLines = this.wrap(ctx, message, maxW).slice(0, 9);
      const blockH = (title ? titleSize * 1.25 : 0) + msgLines.length * msgSize * lh + (sign ? signSize * 1.8 : 0);
      let y = this.image ? S - 96 - blockH : (S - blockH) / 2 + titleSize * 0.4;
      if (this.image && round) y = Math.min(y, S * 0.5 - blockH / 2 + S * 0.12);
      if (light && this.image) { ctx.shadowColor = 'rgba(0,0,0,0.45)'; ctx.shadowBlur = 14; }
      if (title) {
        ctx.fillStyle = color; ctx.font = '400 ' + titleSize + 'px ' + heading;
        y += titleSize; ctx.fillText(title, S / 2, y); y += titleSize * 0.25;
      }
      ctx.fillStyle = color; ctx.font = '400 ' + msgSize + 'px ' + heading;
      msgLines.forEach((l) => { y += msgSize * lh; ctx.fillText(l, S / 2, y); });
      if (sign) {
        ctx.fillStyle = sub; ctx.font = 'italic 400 ' + signSize + 'px ' + heading;
        y += signSize * 1.8; ctx.fillText(sign, S / 2, y);
      }
      if (!title && !message && !sign && !this.image) {
        ctx.fillStyle = light ? 'rgba(255,255,255,0.5)' : 'rgba(28,26,23,0.45)';
        ctx.font = '400 34px ' + body;
        ctx.fillText(this.strings.canvas_empty_1, S / 2, S / 2 - 12);
        ctx.fillText(this.strings.canvas_empty_2, S / 2, S / 2 + 36);
      }
      ctx.restore();
    }

    /* Câmpurile de text → proprietăți. „Poză” și cele două URL-uri se scriu doar la trimitere. */
    syncProps() {
      const p = this.props;
      if (!p.format) return;
      p.format.value = this.shape === 'rotund' ? 'Rotund' : 'Pătrat';
      if (p.title) p.title.value = this.val('title');
      if (p.message) p.message.value = this.val('message');
      if (p.sign) p.sign.value = this.val('sign');
    }

    async upload(blob, name) {
      const fd = new FormData();
      fd.append('file', blob, name);
      fd.append('upload_preset', this.preset);
      const r = await fetch('https://api.cloudinary.com/v1_1/' + this.cloud + '/image/upload', { method: 'POST', body: fd });
      if (!r.ok) throw new Error('upload failed');
      const j = await r.json();
      return j.secure_url;
    }

    showError(msg, quiet) {
      const e = this.q('error');
      if (!e) return;
      e.textContent = msg; e.hidden = !msg;
      if (msg && !quiet) this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    submitButtons(submitter) {
      const list = Array.from(document.querySelectorAll('[data-gf-add]')).filter((b) => b.form === this.form);
      if (submitter && list.indexOf(submitter) < 0) list.push(submitter);
      return list;
    }

    async onSetAdded(detail) {
      if (detail.form && detail.form !== this.form) return;
      if (!this.pendingAddon) return;
      this.pendingAddon = false;
      let quantity = parseInt(detail.quantity, 10);
      if (!(quantity > 0) && this.form) quantity = parseInt(new FormData(this.form).get('quantity'), 10);
      if (!(quantity > 0)) quantity = 1;
      // eșecul se semnalează pe obiectul primit: „Comandă acum” nu mai pleacă la checkout fără add-on
      if (!(await this.addAddon(quantity))) detail.addonFailed = true;
    }

    /* Întoarce false doar când add-on-ul trebuia adăugat și nu a intrat în coș. */
    async addAddon(quantity) {
      if (!this.addonVariant || !this.addonAvailable) return true;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const r = await fetch(root.replace(/\/$/, '') + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(this.addonVariant),
              quantity: quantity,
              properties: { 'Pentru': this.productTitle }
            }]
          })
        });
        if (!r.ok) throw new Error('addon');
        return true;
      } catch (err) {
        // setul e deja în coș; rândul de personalizare se poate adăuga manual
        this.showError(this.t('error_addon'));
        return false;
      }
    }

    async onSubmit(e) {
      const p = this.props;
      if (this.hidden) {
        Object.values(p).forEach((el) => (el.disabled = true));
        this.pendingAddon = false;
        return;
      }
      if (this.passThrough) { this.passThrough = false; return; } // a doua trecere: merge mai departe

      e.preventDefault(); e.stopImmediatePropagation();
      if (this.busy) return;
      this.pendingAddon = false;
      if (!this.val('message') && !this.file) {
        this.showError(this.t('error_empty'));
        // din bara lipicioasă focusul ar rămâne pe <body> (bara devine inertă la derulare)
        const field = this.q('message');
        if (field) field.focus({ preventScroll: true });
        return;
      }
      this.showError('', true);
      this.busy = true;

      const form = this.form;
      const submitter = e.submitter && e.submitter.form === form ? e.submitter : null;
      const buttons = this.submitButtons(submitter).filter((b) => !b.disabled);
      buttons.forEach((b) => { b.setAttribute('aria-busy', 'true'); b.disabled = true; });

      // toate cele 7 proprietăți active și curate înaintea fiecărei trimiteri
      Object.values(p).forEach((el) => (el.disabled = false));
      p.photo_url.value = ''; p.preview_url.value = '';
      this.syncProps();
      try {
        if (this.cloud && this.preset) {
          if (this.file) p.photo_url.value = await this.upload(this.file, this.file.name);
          await this.loadFonts();
          this.draw();
          const blob = await new Promise((res) => this.canvas.toBlob(res, 'image/png'));
          if (blob) p.preview_url.value = await this.upload(blob, 'previzualizare.png');
          p.photo.value = this.file ? 'Încărcată' : 'Fără poză (fundal simplu)';
        } else {
          p.photo.value = this.file ? 'Se trimite după comandă' + (this.dataset.contact ? ' la ' + this.dataset.contact : '') : 'Fără poză (fundal simplu)';
        }
      } catch (err) {
        p.photo.value = this.file ? 'Încărcarea a eșuat – o trimitem după comandă' : 'Fără poză (fundal simplu)';
      }
      // URL-urile goale nu se trimit
      ['photo_url', 'preview_url'].forEach((k) => { if (p[k] && !p[k].value) p[k].disabled = true; });
      // Plasă de siguranță: dacă assets/giftera-product.js nu a pornit (nu s-a încărcat), a doua trecere e un
      // POST nativ și nimeni nu mai rulează afterSetAdded → add-on-ul se adaugă aici, înaintea setului (ca în live).
      const ajax = form.hasAttribute('data-gf-ajax');
      if (!ajax && !this.hidden) {
        let quantity = parseInt(new FormData(form).get('quantity'), 10);
        if (!(quantity > 0)) quantity = 1;
        await this.addAddon(quantity);
      }
      buttons.forEach((b) => { b.removeAttribute('aria-busy'); b.disabled = false; });
      this.busy = false;

      if (this.hidden) return; // între timp s-a ales „Mesajul nostru”: nu trimitem nimic în locul clientului

      // A doua trecere, într-un task nou (requestSubmit e ignorat cât timp formularul încă emite `submit`).
      this.pendingAddon = ajax;
      this.passThrough = true;
      setTimeout(() => {
        try {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined);
          else if (ajax) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          else form.submit(); // fără giftera-product.js nu ascultă nimeni `submit`: POST nativ
        } catch (err) {
          try { form.requestSubmit(); } catch (err2) { this.pendingAddon = false; }
        }
        this.passThrough = false;
      }, 0);
    }
  }

  customElements.define('gf-card-designer', GfCardDesigner);
})();
